'use strict';

define(['app', 'siteObj'], function (app, siteObj) {

  var _footer = {
    _init: function _init() {
      var alternate = '';
      // Check to only run if alt footer
      if (document.getElementById('alt-footer')) {
        alternate = '?alt=true';
      }
      var footerApi = '/' + siteObj.siteDefaultLocale + '/' + siteObj.currencyType + '/footer.nav' + alternate;

      // For Defer loading the footer
      app.ajax.get({
        url: footerApi,
        success: _footer._successCallback,
        error: function error() {
          console.debug('Cannot receive footer. ' + footerApi);
        }
      });
    },

    _successCallback: function _successCallback(result) {
      var footer = document.getElementById('footer') || document.getElementById('alt-footer');
      if (footer) {
        footer.innerHTML = result;
        app.publish('trustpilot/run');
      }
    }
  };

  _footer._init();
  return _footer;
});
//# sourceMappingURL=deferred-footer.js.map
